import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function Row({
  organizationalUnit,
  childrenByParent,
  depth = 1,
  isSelected,
  select,
}: Props) {
  const children = childrenByParent.get(organizationalUnit.uuid) ?? [];

  return (
    <div>
      <div
        className={classNames(styles.name, {
          [styles.selected]: isSelected(organizationalUnit),
        })}
        style={{ paddingLeft: `${1 * depth}rem` }}
        onClick={() => select(organizationalUnit)}
      >
        <p>{organizationalUnit.name}</p>
      </div>
      {children.map((child) => (
        <Row
          key={child.uuid}
          organizationalUnit={child}
          childrenByParent={childrenByParent}
          depth={depth + 1}
          isSelected={isSelected}
          select={select}
        />
      ))}
    </div>
  );
}

export { Row };
